<template>
  <div id="financeTop">
    <div class="title">
      <img src="../../assets/image/icon_caiw@2x.png" style="width:34px" alt />
      <h3>业务</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="clientActive" @tab-click="handleClick">
        <!-- 全部 -->
        <el-tab-pane label="全部" name="1">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input v-model="searchInfo1" placeholder="业务名称"></el-input>
              <!-- <el-date-picker
                v-model="searchDate1"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 5%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='1'" @my-one-change="handleSearchPeopleChange"></one-selected>-->
            </div>
            <div class="right">
              <el-button @click="handleSearch1" class="search">查询</el-button>
              <el-button
                class="creat"
                style="background-color:#40A0F2;"
                @click="addProjectFinanceClick"
              >新增</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:29%">项目名称</div>
                <div class="headerItem" style="width:14%;text-align:center">申请人</div>
                <div class="headerItem" style="width:14%;text-align:center">提交时间</div>
                <div class="headerItem" style="width:18%;text-align:center">状态</div>
                <div class="headerItem" style="width:25%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="tableData1.length>0">
                <li class="tableBodyItem" v-for="item in tableData1" :key="item.id">
                  <div class="bodyItem" style="width:29%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.project_name}}</h3>
                    <p style="color:#999;" class="overflowDoit">
                      <span
                        style="margin-right:10px"
                        v-for="items in item.project_list"
                        :key="items.project_id"
                      >{{items.project_name}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <p class="tableItemContent" v-if="item.member">{{item.member.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:14%;padding-right:0;text-align:center;">
                    <!-- color:#FF3333 -->
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>
                  <div class="bodyItem" style="width:18%;padding-right:0;text-align:center;">
                    <p
                      class="overflowDoit"
                      style="color:#FF3333"
                      v-if="item.show_state=='草稿' || item.show_state=='驳回待修改'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(0, 153, 255)"
                      v-else-if="item.show_state=='已通过'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(48, 173, 95)"
                      v-else-if="item.show_state=='待审批'"
                    >{{item.show_state}}</p>
                    <p
                      class="overflowDoit"
                      style="color:rgb(240, 156, 10)"
                      v-else
                    >{{item.show_state}}</p>

                    <p
                      v-if="item.show_state_people"
                      :title="item.show_state_people"
                      class="overflowDoit"
                    >{{'当前处理人:'+item.show_state_people}}</p>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click="handleCheckReimbursement(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin1==0 ? false : true"
                        @click="handleRemoveReimbursement(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="tableData1.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 弹窗--业务 -->
    <!-- :class="showForm==='showFormAdd' || showForm==='showFormHandle'? 'addClientDia' : 'addOtherDia'" -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      :class="'addClientDia' "
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span
          class="title-name"
          v-if="showForm==='2'"
          style="color:#128BF1;margin-right:5px"
        >{{editName}}-</span>
        <span
          class="title-age"
          v-if="showForm==='showFormAdd'&& addReimbursementForm.is_draft!='1'"
        >新增业务</span>
        <span
          class="title-age"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft=='1'"
        >编辑业务</span>
        <span class="title-age" v-if="showForm==='showFormHandle'">业务详情</span>
      </div>

      <div class="diaContainer yauto">
        <!-- 业务新增表单 -->
        <el-form
          ref="form"
          :model="addReimbursementForm"
          v-if="showForm==='showFormAdd'"
          label-position="right"
          label-width="160px"
        >
          <div class="diaForm_box">
            <div class="diaFormTitle">业务信息</div>
            <div style="box-sizing:border-box;padding:0 10%">
              <!-- 申请人 -->
              <el-form-item
                label="申请人"
                style="margin-bottom:0px;"
                v-if="addReimbursementForm.member"
              >
                <span
                  v-if="addReimbursementForm.member"
                  style="color:#666;font-size:16px"
                >{{addReimbursementForm.member.nickname}}</span>
              </el-form-item>
              <el-form-item label style="margin-bottom:0px;">
                <div style="color:rgb(245, 95, 95)">*此项表单仅为业务录入项目使用，由王总审核</div>
              </el-form-item>
              <!-- 项目名称 -->
              <el-form-item label="项目名称">
                <el-input
                  @blur="handleCheckName"
                  :disabled="draftDisable1"
                  placeholder="请输入项目名称"
                  v-model="addReimbursementForm.project_name"
                ></el-input>
              </el-form-item>
              <!-- 项目类型 -->
              <!-- <el-form-item label="项目类型">
                <el-input
                  :disabled="draftDisable1"
                  placeholder="请输入项目类型"
                  v-model="addReimbursementForm.pte_type"
                ></el-input>
              </el-form-item>-->
              <!-- 登记时间 -->
              <el-form-item label="登记时间">
                <el-date-picker
                  :disabled="draftDisable1"
                  style="width:100%"
                  v-model="addReimbursementForm.record_time"
                  type="date"
                  placeholder="选择登记时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <!-- 金额 -->
              <el-form-item label="金额">
                <el-input
                  :disabled="draftDisable1"
                  type="number"
                  placeholder="请输入金额"
                  v-model="addReimbursementForm.total"
                ></el-input>
              </el-form-item>
              <!-- 附件 -->
              <el-form-item label="附件" style="margin-bottom:10px">
                <upload-file
                  :isSubmit="!draftDisable1"
                  :imgList="this.imgList"
                  :detailsImgList="detailsImgList"
                  @my-upload-change="upLoadChange"
                ></upload-file>
              </el-form-item>
              <!-- 备注 -->
              <el-form-item label="备注" style="margin-bottom:20px">
                <el-input
                  :disabled="draftDisable1"
                  placeholder="请输入备注信息"
                  type="textarea"
                  v-model="addReimbursementForm.remark"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <!-- 业务审批表单 -->
        <el-form
          ref="form"
          :model="addUserForm"
          v-if="showForm==='showFormHandle'"
          label-position="right"
          label-width="160px"
        >
          <div class="diaForm_box diaEditFormBox">
            <div class="ShowFormBtn">
              <el-button
                v-if="addReimbursementForm.withdraw_status=='1'"
                @click="handleFinnaceWithDraw('bproject',addReimbursementForm.id)"
                class="withdrap"
                style="background-color:rgb(255, 26, 26);"
              >撤回</el-button>
              <el-button
                v-if="addReimbursementForm.is_just=='1'"
                @click="handleFinnaceApproveWithDraw('bproject',addReimbursementForm.id)"
                :disabled="disableLimit"
                class="withdrap"
                style="background-color:rgb(255, 26, 26);"
              >审批撤回</el-button>
              <el-button
                @click="approveVisible=true"
                v-if="addReimbursementForm.approval_status=='1'"
                class="creat"
                style="background-color:#40A0F2;"
              >去审批</el-button>

              <!-- <el-button
                @click="handleFinnaceApproval('-1','bproject',addReimbursementForm.id)"
                v-if="addReimbursementForm.approval_status=='1'"
                class="search"
              >驳回</el-button>
              <el-button
                @click="handleFinnaceApproval('1','bproject',addReimbursementForm.id)"
                v-if="addReimbursementForm.approval_status=='1'"
                class="creat"
                style="background-color:#40A0F2;"
              >通过</el-button>-->
            </div>
            <!-- <el-form-item label="驳回节点" v-if="addReimbursementForm.approval_status=='1'">
              <el-select style="width:100%" v-model="k_code" placeholder="请选择">
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addReimbursementForm.stage_select"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>-->

            <!-- <el-form-item label="审批备注" v-if="addReimbursementForm.approval_status=='1'">
              <el-input placeholder="审批备注" type="textarea" v-model="approvalRemark"></el-input>
            </el-form-item>-->
            <div class="diaFormTitle">业务信息</div>
            <div style="box-sizing:border-box;padding:0 10%">
              <!-- 申请人 -->
              <el-form-item
                label="申请人"
                style="margin-bottom:0px;"
                v-if="addReimbursementForm.member"
              >
                <span
                  v-if="addReimbursementForm.member"
                  style="color:#666;font-size:16px"
                >{{addReimbursementForm.member.nickname}}</span>
              </el-form-item>
              <el-form-item label style="margin-bottom:0px;">
                <div style="color:rgb(245, 95, 95)">*此项表单仅为业务录入项目使用，由王总审核</div>
              </el-form-item>
              <!-- 项目名称 -->
              <el-form-item label="项目名称">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  placeholder="请输入项目名称"
                  v-model="addReimbursementForm.project_name"
                ></el-input>
                <span style="color:#666;font-size:16px" v-else>{{addReimbursementForm.project_name}}</span>
              </el-form-item>
              <!-- 项目类型 -->
              <!-- <el-form-item label="项目名称">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  placeholder="请输入项目名称"
                  v-model="addReimbursementForm.pte_type"
                ></el-input>
                <span style="color:#666;font-size:16px" v-else>{{addReimbursementForm.pte_type}}</span>
              </el-form-item>-->
              <!-- 登记时间 -->
              <el-form-item label="登记时间">
                <el-date-picker
                  v-if="addReimbursementForm.is_edit=='1'"
                  style="width:100%"
                  v-model="addReimbursementForm.record_time"
                  type="date"
                  placeholder="选择登记时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                <span style="color:#666;font-size:16px" v-else>{{addReimbursementForm.record_time}}</span>
              </el-form-item>
              <!-- 金额 -->
              <el-form-item label="金额">
                <el-input
                  v-if="addReimbursementForm.is_edit=='1'"
                  type="number"
                  placeholder="请输入金额"
                  v-model="addReimbursementForm.total"
                ></el-input>
                <span style="color:#666;font-size:16px" v-else>{{addReimbursementForm.total}}</span>
              </el-form-item>
              <!-- 附件 -->
              <el-form-item label="附件" style="margin-bottom:10px">
                <upload-file
                  :isSubmit="addReimbursementForm.is_edit=='1'"
                  :imgList="this.imgList"
                  :detailsImgList="detailsImgList"
                  @my-upload-change="upLoadChange"
                ></upload-file>
              </el-form-item>
              <!-- 备注 -->
              <el-form-item label="备注" style="margin-bottom:20px">
                <el-input
                  placeholder="请输入备注信息"
                  type="textarea"
                  v-if="addReimbursementForm.is_edit=='1'"
                  v-model="addReimbursementForm.remark"
                ></el-input>
                <el-input
                  type="textarea"
                  class="onlyShowText"
                  disabled
                  autosize
                  v-else
                  v-model="addReimbursementForm.remark"
                ></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="diaForm_box diaEditFormBox">
            <div class="diaFormTitle">审批信息</div>
            <div style="box-sizing:border-box;padding:0 10%">
              <!-- 已通过 -->
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in addReimbursementForm.approval_log"
                  :key="index"
                >
                  <div style="margin-bottom:5px">
                    <span>提交人:</span>
                    <span>{{activity.memberInfo.nickname}}</span>
                    <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                    <span>{{activity.add_time}}</span>
                  </div>
                  <div>
                    <span
                      v-if="activity.approval_status=='1'"
                      style="margin-right:10px"
                    >{{activity.executorInfo.nickname}}</span>
                    <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                    <span
                      v-if="activity.approval_status=='-1'"
                      style="margin-right:10px"
                    >{{activity.executorInfo.nickname}}</span>
                    <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                    <span
                      v-if="activity.approval_status=='0'"
                      v-for="item in activity.tomemberInfo"
                      style="margin-right:10px"
                    >{{item.nickname+' '}}</span>
                    <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                    <span
                      style="margin-left:10px"
                      v-if="activity.update_time"
                    >{{activity.update_time}}</span>
                  </div>
                  <div class="remark" style="margin-top:5px" v-if="activity.remark">
                    <span style="margin-right:5px">备注:</span>
                    <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- 报销新增按钮 -->
        <el-button
          style="background-color: #ccc;"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft!='1'"
          @click="handleAddReimbursementSubmit('1')"
        >保存草稿</el-button>
        <el-button
          type="primary"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft!='1'"
          @click="handleAddReimbursementSubmit('0')"
        >提 交</el-button>
        <!-- 报销编辑按钮 -->
        <el-button
          style="background-color: #ccc;"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft=='1' && !draftDisable1"
          @click="handleEditReimbursementSubmit('1')"
        >保存草稿</el-button>
        <el-button
          type="primary"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft=='1' && !draftDisable1"
          @click="handleEditReimbursementSubmit('0')"
        >提 交</el-button>
        <!-- 报销重新提交按钮 -->
        <el-button
          style="background-color: #ccc;"
          v-if="showForm==='showFormHandle' && addReimbursementForm.is_edit=='1'"
          @click="dialogVisible=false"
        >取 消</el-button>
        <el-button
          type="primary"
          v-if="showForm==='showFormHandle' && addReimbursementForm.is_edit=='1'"
          @click="handleEditReimbursementSubmit('0')"
        >提 交</el-button>
      </div>
    </el-dialog>
    <!-- 名称检测弹窗 -->
    <el-dialog
      :visible.sync="dialogVisibleCheckName"
      width="60%"
      :before-close="handleCloseCheckName"
      :class="'addClientDia' "
      @close="handleClosedCheckName"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">名称检测</span>
      </div>
      <div style="min-height:60vh">
        <el-table
          :border="true"
          :data="nameCheckList"
          v-if="this.nameCheckList.length>0"
          @row-click="tableRowClick"
        >
          <el-table-column align="center" label="项目名称">
            <template slot-scope="scope">
              <!-- @click="goProjectDetailsOpenNew(scope.row)" -->
              <span class="tableNameCurrent">{{scope.row.project_name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="member_show" align="center" label="申请人姓名"></el-table-column>
        </el-table>
        <div v-else style="text-align:center;">没有相似企业名称</div>
      </div>
    </el-dialog>
    <!-- 名称检测来的详情页 -->
    <el-dialog
      :visible.sync="dialogVisibleCheckDetails"
      width="60%"
      :before-close="handleCloseCheckDetails"
      :class="'addClientDia' "
      @close="handleClosedCheckDetails"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span
          class="title-name"
          v-if="showFormCheckName==='2'"
          style="color:#128BF1;margin-right:5px"
        >{{editName}}-</span>
        <span
          class="title-age"
          v-if="showFormCheckName==='showFormAdd'&& checkNameData.is_draft!='1'"
        >新增业务</span>
        <span
          class="title-age"
          v-if="showFormCheckName==='showFormAdd' && checkNameData.is_draft=='1'"
        >编辑业务</span>
        <span class="title-age" v-if="showFormCheckName==='showFormHandle'">业务详情</span>
      </div>

      <div class="diaContainer yauto">
        <!-- 业务审批表单 -->
        <el-form
          ref="form"
          :model="addUserForm"
          v-if="showFormCheckName==='showFormHandle'"
          label-position="right"
          label-width="160px"
        >
          <div class="diaForm_box diaEditFormBox">
            <div class="diaFormTitle">业务信息</div>
            <div style="box-sizing:border-box;padding:0 10%">
              <!-- 申请人 -->
              <el-form-item label="申请人" style="margin-bottom:0px;" v-if="checkNameData.member">
                <span
                  v-if="checkNameData.member"
                  style="color:#666;font-size:16px"
                >{{checkNameData.member.nickname}}</span>
              </el-form-item>
              <el-form-item label style="margin-bottom:0px;">
                <div style="color:rgb(245, 95, 95)">*此项表单仅为业务录入项目使用，由王总审核</div>
              </el-form-item>
              <!-- 项目名称 -->
              <el-form-item label="项目名称">
                <span style="color:#666;font-size:16px">{{checkNameData.project_name}}</span>
              </el-form-item>
              <!-- 登记时间 -->
              <el-form-item label="登记时间">
                <span style="color:#666;font-size:16px">{{checkNameData.record_time}}</span>
              </el-form-item>
              <!-- 金额 -->
              <el-form-item label="金额">
                <span style="color:#666;font-size:16px">{{checkNameData.total}}</span>
              </el-form-item>
              <!-- 附件 -->
              <el-form-item label="附件" style="margin-bottom:10px">
                <upload-file
                  :isSubmit="false"
                  :imgList="this.imgList"
                  :detailsImgList="detailsImgList"
                  @my-upload-change="upLoadChange"
                ></upload-file>
              </el-form-item>
              <!-- 备注 -->
              <el-form-item label="备注" style="margin-bottom:20px">
                <el-input
                  type="textarea"
                  class="onlyShowText"
                  disabled
                  autosize
                  v-model="checkNameData.remark"
                ></el-input>
              </el-form-item>
            </div>
          </div>

          <div class="diaForm_box diaEditFormBox">
            <div class="diaFormTitle">审批信息</div>
            <div style="box-sizing:border-box;padding:0 10%">
              <!-- 已通过 -->
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in checkNameData.approval_log"
                  :key="index"
                >
                  <div style="margin-bottom:5px">
                    <span>提交人:</span>
                    <span>{{activity.memberInfo.nickname}}</span>
                    <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                    <span>{{activity.add_time}}</span>
                  </div>
                  <div>
                    <span
                      v-if="activity.approval_status=='1'"
                      style="margin-right:10px"
                    >{{activity.executorInfo.nickname}}</span>
                    <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                    <span
                      v-if="activity.approval_status=='-1'"
                      style="margin-right:10px"
                    >{{activity.executorInfo.nickname}}</span>
                    <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                    <span
                      v-if="activity.approval_status=='0'"
                      v-for="item in activity.tomemberInfo"
                      style="margin-right:10px"
                    >{{item.nickname+' '}}</span>
                    <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                    <span
                      style="margin-left:10px"
                      v-if="activity.update_time"
                    >{{activity.update_time}}</span>
                  </div>
                  <div class="remark" style="margin-top:5px" v-if="activity.remark">
                    <span style="margin-right:5px">备注:</span>
                    <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <!-- 弹窗--审批 -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia addClientDia1"
      :before-close="approveVisibleClose"
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addReimbursementForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addReimbursementForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addReimbursementForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择">
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addReimbursementForm.stage_select"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addReimbursementForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addReimbursementForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="handleFinnaceApproval('-1','bproject',addReimbursementForm.id)"
          :disabled="disableLimit"
          style="background:#f4a029;"
          v-if="addReimbursementForm.approval_status=='1'"
          class="search"
        >驳回</el-button>
        <el-button
          @click="handleFinnaceApproval('1','bproject',addReimbursementForm.id)"
          :disabled="disableLimit"
          v-if="addReimbursementForm.approval_status=='1'"
          class="creat"
          style="background-color:#40A0F2;"
        >通过</el-button>
      </div>
    </el-dialog>
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>
  </div>
</template>
<script>
import echarts from 'echarts'
import Draggable from 'vuedraggable'
import UploadFile from '../../components/UploadFile'
import OneSelected from '../../components/OneSelected'
import SignDialog from '../../components/SignDialog'

export default {
  data() {
    return {
      receiverSignFlag: false,
      isAdmin1: '',
      disableLimit: false,
      // 审批窗口
      approveVisible: false,
      sign_pic: '',
      receiverSignFlag: false,
      k_code: '',
      is_chase: '0',
      // 弹窗
      dialogVisible: false,
      imgList: [],
      checkOutImgIndex: '',
      // 弹窗
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      searchInfo1: '',
      searchDate: '',
      searchDate1: '',
      searchDate2: '',
      editName: '',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      showForm: '',
      clientActive: '1',
      searchInfo1: '',

      dialogVisible: false,
      // 新增成员
      addUserForm: {
        customer_name: '',
        project_type: [],
        type: '0',
        is_company: '0',
        source: '',
        describe: '',
        remark: '',
        contacts: '',
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.searchDate2) {
            return (
              time.getTime() > new Date(this.searchDate2).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.searchDate1) {
            return (
              time.getTime() <
                new Date(this.searchDate1).getTime() - 86400000 ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      tableData1: [],

      draftDisable1: false,

      financeIndexData: {},
      // 新增邮寄
      addReimbursementForm: {
        remark: '',
        annex: '',
        project_id: [],
        project_name: '',
        pte_type: '',
        record_time: '',
        total: 0,
      },
      // 新增报告用章审批
      addSettlementForm: {
        remark: '',
        annex: '',
        project_id: [],
        seal_type: '1',
        num: 1,
        business_name: '',
      },
      // 新增其他用章审批
      addExpertForm: {
        remark: '',
        annex: '',
        project_id: [],

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      },
      selectProjectNum: '',
      projectList: [],
      approvalRemark: '',
      imgSize: '100%',
      detailsImgList: [],
      SearchPeopleId: '',
      tiemID: null,
      timeDou: 100,

      // 检测名字
      nameCheckList: [],
      dialogVisibleCheckName: false,
      dialogVisibleCheckDetails: false,
      checkNameData: {},
      draftDisableCheck: false,
      showFormCheckName: '',
    }
  },
  components: {
    Draggable,
    UploadFile,
    OneSelected,
    SignDialog,
  },
  methods: {
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},
    // 点击检测名字的详情
    async tableRowClick(scope) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', scope.id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/BProject/bproject_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.checkNameData = res.datas.info
      // 处理项目
      // 处理图片
      if (this.checkNameData.annex) {
        this.imgList = this.checkNameData.annex
        this.detailsImgList = this.checkNameData.annex
      }
      // 处理驳回节点
      if (this.checkNameData.stage_select) {
        this.checkNameData.stage_select.forEach((item, index) => {
          item.id = index
          item.label = ''
          item.forEach((items) => {
            item.label += items.nickname + '/'
          })
          item.label = item.label.slice(0, item.label.length - 1)
        })
      }
      console.log('检测名字详情', this.checkNameData)
      this.showFormCheckName = 'showFormHandle'

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.draftDisableCheck = true
      } else {
        this.draftDisableCheck = false
      }

      this.dialogVisibleCheckDetails = true
    },
    // 失去焦点校验名称
    async handleCheckName() {
      if (this.addReimbursementForm.project_name) {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('search', this.addReimbursementForm.project_name)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/BProject/bproject_name_check',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        if (res.datas.listInfo && res.datas.listInfo.length > 0) {
          this.nameCheckList = res.datas.listInfo
          this.dialogVisibleCheckName = true
        }
      }
    },
    // 撤回
    async handleFinnaceWithDraw(stage_code, finance_id) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      if (stage_code == 'bproject') {
        this.getReimbursementList()
      }
      this.dialogVisible = false
    },
    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.SearchPeopleId = data
    },

    upLoadChange(data) {
      this.imgList = data
    },
    handleSearch1() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
      }
      this.currentPage = 1
      this.getReimbursementList()
    },

    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      if (stage_code == 'bproject') {
        this.getReimbursementList()
      }
      this.dialogVisible = false
    },

    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('is_chase', this.is_chase)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)
      this.approveVisible = false
      if (stage_code == 'bproject') {
        this.getReimbursementList()
      }

      this.dialogVisible = false
    },

    // *编辑业务提交
    async handleEditReimbursementSubmit(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('project_id', this.addReimbursementForm.id)

        param.append('project_name', this.addReimbursementForm.project_name)
        param.append('pte_type', this.addReimbursementForm.pte_type)
        param.append('record_time', this.addReimbursementForm.record_time)
        param.append('total', this.addReimbursementForm.total)

        param.append('remark', this.addReimbursementForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        // param.append(
        //   'project_id',
        //   this.addReimbursementForm.project_id.join(',')
        // )

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/BProject/bproject_edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)

        this.getReimbursementList()
        this.dialogVisible = false
      }, this.timeDou)
    },
    // *查看业务详情
    async handleCheckReimbursement(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/BProject/bproject_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addReimbursementForm = res.datas.info
      // 处理项目
      // 处理图片
      if (this.addReimbursementForm.annex) {
        this.imgList = this.addReimbursementForm.annex
        this.detailsImgList = this.addReimbursementForm.annex
      }
      // 处理驳回节点
      if (this.addReimbursementForm.stage_select) {
        this.addReimbursementForm.stage_select.forEach((item, index) => {
          item.id = index
          item.label = ''
          item.forEach((items) => {
            item.label += items.nickname + '/'
          })
          item.label = item.label.slice(0, item.label.length - 1)
        })
      }
      console.log('邮寄详情', this.addReimbursementForm)
      if (res.datas.info.is_draft == '1') {
        this.showForm = 'showFormAdd'
      } else {
        this.showForm = 'showFormHandle'
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.draftDisable1 = true
      } else {
        this.draftDisable1 = false
      }

      this.dialogVisible = true
    },
    // *业务点击提交
    async handleAddReimbursementSubmit(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('project_name', this.addReimbursementForm.project_name)
        param.append('record_time', this.addReimbursementForm.record_time)
        param.append('pte_type', this.addReimbursementForm.pte_type)
        param.append('total', this.addReimbursementForm.total)

        param.append('remark', this.addReimbursementForm.remark)
        param.append('annex', JSON.stringify(this.imgList))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/BProject/bproject_add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)

        this.getReimbursementList()
        this.dialogVisible = false
      }, this.timeDou)
    },
    // *业务删除
    async handleRemoveReimbursement(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/BProject/bproject_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getReimbursementList()
      }
    },
    // *获取业务列表
    async getReimbursementList() {
      // Finance/reimbursement
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('search', this.searchInfo1)
      // param.append('search_member_id', this.SearchPeopleId)
      // param.append('date_start', this.searchDate1)
      // param.append('date_end', this.searchDate2)

      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/BProject/bproject',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.tableData1 = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      // :disabled="isAdmin1==0 ? false : true"
      this.isAdmin1 = res.datas.admin_state

      console.log('邮寄列表', this.tableData1)
    },

    // 点击新增报销按钮
    addProjectFinanceClick() {
      this.showForm = 'showFormAdd'
      this.dialogVisible = true
    },
    handleClick(tab, event) {
      this.searchInfo1 = ''
      this.searchDate1 = ''
      this.searchDate2 = ''
      this.SearchPeopleId = ''
      this.pageSize = 10
      this.currentPage = 1
      console.log(tab, event)
      if (tab.name == '1') {
        this.getReimbursementList()
      }
    },
    handleCloseCheckName() {
      this.dialogVisibleCheckName = false
    },
    handleClosedCheckName() {},
    handleCloseCheckDetails() {
      this.dialogVisibleCheckDetails = false
    },
    handleClosedCheckDetails() {},
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.imgList = []
      this.selectProjectNum = ''
      this.k_code = ''
      this.approvalRemark = ''
      this.draftDisable1 = false
      // 清空邮寄相关
      this.addReimbursementForm = {
        remark: '',
        annex: '',
        project_id: [],
        project_name: '',
        record_time: '',
        total: 0,
      }
      // 新增邮寄
      // 报告用章审批
      this.addSettlementForm = {
        remark: '',
        annex: '',
        project_id: [],
        seal_type: '1',
        num: 1,
        business_name: '',
      }
      // 清空其他用章审批
      this.addExpertForm = {
        remark: '',
        annex: '',
        project_id: [],

        seal_type: '1',
        num: 1,
        business_name: '',
        reason_id: '1',
        reason_else: '',
        manager: '',
      }
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      if (this.clientActive == 1) {
        this.getReimbursementList()
      }
      if (this.clientActive == 2) {
        this.getSettlementList()
      }
      if (this.clientActive == 3) {
        this.getExpertList()
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      if (this.clientActive == 1) {
        this.getReimbursementList()
      }
      if (this.clientActive == 2) {
        this.getSettlementList()
      }
      if (this.clientActive == 3) {
        this.getExpertList()
      }
    },
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.activeName = this.$route.query.type
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    this.getReimbursementList()
  },
  mounted() {},
  computed: {},
}
</script>
<style lang="less" scoped>
#financeTop {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;

  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;

    // 引入项目财务样式
    .btnRow {
      width: 100%;
      display: flex;
      align-content: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .fffBorder {
        /deep/.el-input__inner {
          background-color: #fff !important;
          border: 1px solid #ebebeb !important;
        }
      }
      .left {
        width: 50%;
        display: flex;
        /deep/.el-input {
          width: 40%;
          margin-right: 10%;
          // (deep)
          // (deep)
          .el-input__inner {
            height: 45px;
            border-radius: 24px;
            font-size: 16px;
            border: none;
            background-color: #f4f5f6;
            color: #333;
            &::placeholder {
              color: #333;
            }

            &::-webkit-input-placeholder {
              /* WebKit browsers 适配谷歌 */
              color: #333;
            }

            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 适配火狐 */
              color: #333;
            }
          }
        }
      }
      /deep/.el-button {
        font-size: 18px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 45px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
    }
    .totalNum {
      width: 100%;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 3px;
      margin-bottom: 20px;
      li {
        width: 16%;
        height: 120px;
        border-radius: 10px;
        box-shadow: 1px 3px 9px 0px rgba(3, 70, 126, 0.14);
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          font-size: 20px;
          padding: 0;
          margin-top: 25px;
          margin-bottom: 10px;
        }
        .number {
          font-size: 24px;
        }
      }
    }
    .echartsRow {
      height: calc(100% - 68px - 120px - 20px - 20px);
      box-sizing: border-box;
      padding: 0 3px;
      display: flex;
      .leftEcharts {
        width: 49.1%;
        box-shadow: 1px 3px 9px 0px rgba(3, 70, 126, 0.14);
        margin-right: 1.8%;
        border-radius: 10px;
      }
      .rightEcarts {
        width: 49.1%;
        box-shadow: 1px 3px 9px 0px rgba(3, 70, 126, 0.14);
        border-radius: 10px;
      }
    }
    // 表格行
    .financeTable {
      width: 100%;
      height: calc(100% - 138px);
      .table {
        width: 100%;
        height: 100%;
        .table_head {
          box-sizing: border-box;
          padding: 0 40px;
          width: 100%;
          height: 60px;
          font-size: 18px;
          color: #fff;
          background-color: #40a0f2;
          display: flex;
          align-items: center;
        }
        .table__body {
          box-sizing: border-box;
          height: calc(100% - 60px);
          width: 100%;
          overflow-y: auto;
          padding: 0 2px;
          // li
          .tableBodyItem {
            cursor: pointer;
            box-sizing: border-box;
            padding: 13px 40px;
            border-bottom: 1px solid #ebebeb;
            width: 100%;
            height: 8vh;
            display: flex;
            .bodyItem {
              box-sizing: border-box;
              padding-right: 30px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .knowledgeTitle {
                margin-bottom: 4px;
                font-size: 18px;
                font-weight: normal;
                color: #333333;
              }
              p {
                font-size: 14px;
                color: #666666;
              }
              .tableItemContent {
                width: 100%;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              .tableBtnRow {
                width: 100%;
                display: flex;
                justify-content: center;
                /deep/.el-button {
                  padding: 0 24px;
                  display: flex;
                  align-items: center;
                  font-weight: normal;
                  height: 32px;
                }
                /deep/.edit {
                  margin-right: 10px;
                  color: rgb(245, 95, 95);
                  border-color: rgb(245, 95, 95);
                }
                /deep/.check {
                  color: #10981d;
                  border-color: #66c16f;
                  margin-right: 10px;
                }
              }
              .overflowDoit {
                width: 100%;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
            }

            .headerLogo {
              width: 46px;
              height: 46px;
              border-radius: 50%;
              margin-left: 10px;
            }
          }
          .tableBodyItem:hover {
            box-shadow: 0px 0px 9px 0px rgba(3, 70, 126, 0.14);
            .knowledgeTitle {
              color: #128bf1;
            }
          }
        }
      }

      // 分页行
      .pageRow {
        height: 20px;
        box-sizing: border-box;
        margin-top: 10px;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: flex-end;
        /deep/.el-pagination .el-select .el-input .el-input__inner {
          font-size: 14px;
        }
        /deep/.el-pagination button,
        /deep/.el-pagination span:not([class*='suffix']) {
          font-size: 14px;
        }
      }
    }
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 引入项目财务样式

    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 40px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #666;
      font-weight: 700;
      padding-right: 100px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #409eff !important;
    }
    /deep/.el-tabs__item:hover {
      color: #409eff !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }

  // dialog弹窗
  // 修改弹窗引入别的
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 45px;
      padding: 0;
      font-size: 18px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 10px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }
  // img dia 尾部
  .imgFooter {
    padding-left: 0;
    justify-content: center;
    margin-bottom: 20px;
  }

  /deep/.el-form-item {
    margin-bottom: 15px;
  }
  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    font-weight: 700;
    box-sizing: border-box;
    padding-right: 40px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    // display: flex;
    /deep/.el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: 18px;
      }
    }
    .el-input__inner {
      // font-size: 14px;
      font-size: inherit;
      width: 100%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 100%;
      .el-textarea__inner {
        height: 70px;
        // font-size: 14px;
        min-height: 70px !important;
        font-size: inherit;
        resize: none;
        border-radius: 0;
        font-family: Microsoft YaHei;
      }
    }
    .el-radio-group {
      height: 35px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .el-radio {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        // margin-right: 15%;
        width: 25%;
      }
      .el-radio__input {
        width: 16px;
        height: 16px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 14px;
        padding-left: 5px;
      }
    }
  }
  .diaForm_box {
    width: 100%;
    padding-left: 50px;
    box-sizing: border-box;
    /deep/.labelFormItem {
      /deep/.ProjectType {
        width: 80%;
        flex-wrap: wrap;
        height: initial;
        max-height: 105px;
        overflow-y: auto;
        /deep/.el-radio {
          // width: 30%;
          height: 35px;
        }
        /deep/.el-checkbox {
          width: 20%;
          .el-checkbox__label {
            font-size: 16px;
            font-weight: normal;
          }
        }
      }
      /deep/.el-form-item__label {
        line-height: 36px;
      }
    }
    .inputTwoRow {
      box-sizing: border-box;
      // padding: 0 16%;
      // padding-right: 14%;
      width: 100%;
      display: flex;
      /deep/.el-form-item:nth-child(2) {
        margin-left: 10%;
      }
      /deep/.el-input__inner {
        width: 100%;
      }
    }
    .diaFormTitle {
      width: 100%;
      font-weight: bold;
      color: #128bf1;
      font-size: 18px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .diaFormTitle::before {
      content: '';
      display: block;
      width: 3px;
      height: 16px;
      background-color: #40a0f2;
      margin-right: 5px;
    }
    .diaFormTitle1 {
      width: 100%;
      font-weight: bold;
      color: #128bf1;
      font-size: 18px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .diaFormTitle1 span {
      display: flex;
      align-items: center;
    }
    .diaFormTitle1 span::before {
      content: '';
      display: block;
      width: 3px;
      height: 16px;
      background-color: #40a0f2;
      margin-right: 5px;
    }
  }
  .diaEditFormBox {
    .el-form-item {
      margin-bottom: 8px;
    }
    /deep/.el-form-item__label {
      line-height: 30px;
    }
    /deep/.el-form-item__content {
      line-height: 30px;
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  // 修改弹窗引入别的
  .shenpiBtn {
    display: flex;
    justify-content: flex-end;
    padding-right: 100px;
    box-sizing: border-box;
    /deep/.el-button {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 130px;
      height: 45px;
      border-radius: 24px;
      font-size: 18px;
      font-weight: 400;
      background-color: #40a0f2;
      margin-left: 40px;
      color: #fff;
      border: none;
    }
  }

  // **修改自动计算的价钱的disable÷
  /deep/.computedDisable .is-disabled .el-input__inner {
    background-color: #fff;
  }
  // **修改自动计算的价钱的disable÷
}

// 修改弹窗样式
.addClientDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 5vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
    .el-dialog__footer {
      padding-bottom: 10px;
    }
  }
}
.addClientDia1 {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 20vh !important;
  }
}
.addOtherDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
    .el-dialog__footer {
      padding-bottom: 10px;
    }
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
.upload-demo {
  display: flex;
  align-items: flex-end;
  /deep/.el-button {
    padding: 0;
    border: none;
    background-color: #fff;
    color: #128bf1;
    font-size: 16px;
    font-weight: normal;
    img {
      width: 19px;
      height: 14px;
    }
  }
}
/deep/.el-upload-list__item-name {
  display: none;
}
// 上传图片组件
.upLoadImgList > div {
  display: flex;
  flex-wrap: wrap;
}
.upLoadImgList {
  display: flex;
  flex-wrap: wrap;
  .upLoadImgBox {
    width: 100px;
    height: 85px;
    margin-right: 15px;
    margin-bottom: 15px;
    .closeBox {
      width: 100%;
      height: 100%;
      position: relative;
      .closeIcon {
        display: none;
        cursor: pointer;
        font-size: 20px;
        color: #128bf1;
        position: absolute;
        right: -5px;
        top: -5px;
      }
    }
    /deep/.closeBox:hover .closeIcon {
      display: block !important;
    }

    /deep/.el-avatar--square {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .upLoadImgBox {
    width: 100px;
    height: 85px;
    margin-right: 15px;
    margin-bottom: 15px;
    .closeBox {
      width: 100%;
      height: 100%;
      position: relative;
      .closeIcon {
        display: none;
        cursor: pointer;
        font-size: 20px;
        color: #128bf1;
        position: absolute;
        right: -5px;
        top: -5px;
      }
    }
    /deep/.closeBox:hover .closeIcon {
      display: block !important;
    }

    /deep/.el-avatar--square {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .addUpLoadBtn {
    height: 85px;
    display: flex;
    align-items: flex-end;
    .upload-demo {
      height: 25px;
      align-items: center;
    }
  }
}
.ShowFormBtn {
  width: 100%;
  box-sizing: border-box;
  padding-right: 50px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  /deep/.el-button {
    font-size: 18px;
    font-weight: normal;
    border: none;
    width: 130px;
    height: 45px;
    background: #f4a029;
    color: #fff;
    border-radius: 24px;
    padding: 0;
    margin-left: 30px;
  }
}

.imgDetails {
  height: 70vh;
  width: 100%;
  overflow: scroll;
  display: flex;
  justify-content: center;
}

// 禁用表单样式
/deep/.el-input.is-disabled .el-input__inner {
  color: #999;
  background-color: #f2f5f9;
}
/deep/.el-radio__input.is-disabled + span.el-radio__label {
  color: #999;
}
// 禁用textarea
/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #999;
  background-color: #f2f5f9;
}
.yauto {
  height: calc(80vh - 70px);
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
.table__body::-webkit-scrollbar {
  width: 5px !important;
}
.table__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.table__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
// 修改人员选择(搜索栏的人员选择)
/deep/#MyTransfer {
  width: 40%;
  .filter-dash-btn {
    border: none;
    border-radius: 24px;
    background-color: #f4f5f6;
    height: 45px;
    font-size: 16px;
    color: #333;
    .filter-tips-default {
      color: #333;
    }
  }
  .checked-app-item {
    margin-left: 10px;
    border: none;
    background-color: #f4f5f6;
  }
}
// 修改禁用textArea样式
/deep/.onlyShowText {
  .el-textarea__inner {
    border: none !important;
    box-sizing: border-box !important;
    background-color: #fff !important;
    padding: 0 !important;
    padding-top: 5px !important;
    // color: #333 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 16px !important;
  }
}
// 修改选择项目的尺寸过长展示不全
/deep/.el-select__tags > span {
  width: 100%;
  .el-tag {
    height: auto;
    max-width: 100% !important;
    white-space: pre-wrap;
    .el-select__tags-text {
      max-width: 100%;
      white-space: pre-wrap;
    }
  }
}
</style>